export default __webpack_public_path__ + "media/images/mute-b336798f6b47c495725e53adf9c5fa99.svg";